module.exports = __webpack_public_path__ + "img/applySharer_success.5bff1b28.png";